import { DeferredCreditGroupDto } from './DeferredCreditGroupDto';
import {
  CreditGroupInput as CreditGroupInputType,
  CreditInput as CreditInputType,
  DeferredCreditGroupInput as DeferredCreditGroupInputType,
  DeferredCreditInput as DeferredCreditInputType,
  FinanceCalculationParamsInput,
} from '../../api/graphql/generated/schema';
import { DeferredCreditDto } from './DeferredCreditDto';
import { CreditGroupDto } from './CreditGroupDto';
import { CreditDto } from './CreditDto';
import { CalculationConfigDto } from '../finance/calculation/calculationConfig';

const convertToCreditGroupInput = (creditGroup: CreditGroupDto): CreditGroupInputType => {
  return {
    type: creditGroup.type,
    items: creditGroup.items.map((item) => {
      return {
        month: item.month,
        monthlyInstalment: item.monthlyInstalment,
        advancePayment: item.advancedPayment,
      };
    }),
    creditCalculationParams: convertToCreditCalculationParamsInput(creditGroup.creditCalculationParams),
  };
};

export const convertToCreditCalculationParamsInput = (
  calculationParams?: Readonly<CalculationConfigDto>,
): FinanceCalculationParamsInput | undefined => {
  if (!calculationParams) return undefined;
  if (
    !calculationParams?.insuranceId ||
    !calculationParams.insurancePackageId ||
    !calculationParams.insuranceDeductible ||
    !calculationParams.insuranceWindshieldLimit ||
    !calculationParams.clientAge ||
    !calculationParams.claimFreeMonths
  ) {
    throw new Error('Missing required parameters for credit calculation parameters');
  }
  return {
    productId: calculationParams.productId || '',
    insuranceId: calculationParams.insuranceId,
    insurancePackageId: calculationParams.insurancePackageId,
    insuranceDeductible: calculationParams.insuranceDeductible,
    insuranceWindshieldLimit: calculationParams.insuranceWindshieldLimit,
    automaticCalculation: calculationParams.automaticCalculation || false,
    carPriceDiscount: calculationParams.carPriceDiscount,
    contraAccount: calculationParams.contraAccount || false,
    totalModelPrice: calculationParams.totalModelPrice,
    claimFreeMonths: calculationParams.claimFreeMonths,
    clientAge: calculationParams.clientAge,
    regDateFirst: calculationParams.regDateFirst,
  };
};

const convertToDeferredCreditGroupInput = (creditGroup: DeferredCreditGroupDto): DeferredCreditGroupInputType => {
  return {
    type: creditGroup.type,
    items: creditGroup.items.map((item) => {
      return {
        month: item.month,
        monthlyInstalment: item.monthlyInstalment,
        advancePayment: item.advancedPayment,
        deferredPayment: item.deferredPayment,
        purchasePrice: item.purchasePrice,
      };
    }),
  };
};

export const convertToCreditInput = (credit: CreditDto): CreditInputType | undefined => {
  if (credit.serviceId) {
    return {
      serviceId: credit.serviceId,
      creditGroups: credit.creditGroups.map((cg) => convertToCreditGroupInput(cg)),
    };
  } else {
    return undefined;
  }
};

export const convertToDeferredCreditInput = (credit: DeferredCreditDto): DeferredCreditInputType | undefined => {
  if (credit.serviceId) {
    return {
      serviceId: credit.serviceId,
      deferredCreditGroups: credit.creditGroups.map((cg) => convertToDeferredCreditGroupInput(cg)),
    };
  } else {
    return undefined;
  }
};
